import React from 'react';
import MenuCard from '../MenuCard';
import { data1, data2 } from '../../data/data'; // Import data2 as well
import './style.css';

export default function MenuItem({ famille, dataType }) {
  // Determine which data to use based on dataType
  console.log(dataType)
  const data = dataType === "data1" ? data1 : data2;

  // Filter products by family
  const filteredData = data.filter(produit => produit.famille === famille);

  // Map the filtered products to MenuCard components
  const menuItems = filteredData.map((produit) => (
    <div key={produit._id}>
      <MenuCard
        id={produit._id}
        name={produit.articleNom}
        composition={produit.compo}
        price={produit.prix}
        famille={produit.famille}
      />
    </div>
  ));

  return <>{menuItems}</>;
}
